module.exports = __webpack_public_path__ + "media/images/logo/sns/line-a2779bf14d04b4667fb1493e80c3c76e.png";